module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/beast/repos/athlos-admin/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main